<template>
    <div>
        <rkm-data-table
            :fields="fields"
            :repository="repositories.saida"
            :disabled-button-search="true"
            ref="DataTable"
            sort-by="dataRequisicao"
            search-by="unidadeNomeFantasia"
        >
            <template v-slot:cell(finalizada)="{ value }">
                {{ value ? 'SIM' : 'NÃO' }}
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click.stop="handleEdit(item)"
                    authorize="update-almoxarifado-saida"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="!!item.finalizada"
                    @click.stop="handleDestroy(item)"
                    color="danger"
                    authorize="destroy-almoxarifado-saida"
                    :title="item.finalizada ? 'Não é permitido excluir saída finalizada' : 'Excluir'"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-data-table>
    </div>
</template>

<script>
// Mixins.
import { repository, error, formats } from '@/mixins'

import moment from 'moment'
import { mapActions } from 'vuex'

export default {
    created() {

        this.repositories = {
            saida: this.getConectaSusRepository('almoxarifado.saida'),
            balancete: this.getConectaSusRepository('almoxarifado.balancete'),
        }
    },
    computed: {
        fields() {

            return [
                {
                    name: 'almoxarifadoSaidaRequisicao.data',
                    key: 'dataRequisicao',
                    label: 'Data da requisição',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'cadastroUnidade.nomeFantasia',
                    key: 'unidadeNomeFantasia',
                    label: 'Unidade',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'cadastroInfraestrutura.nome',
                    key: 'infraestruturaNome',
                    label: 'Local de atendimento',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'cadastroSetor.nome',
                    key: 'setorNome',
                    label: 'Setor',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'cadastroCidadao.nome',
                    key: 'usuarioNome',
                    label: 'Usuário',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'almoxarifadoSaidaRequisicao.numero',
                    key: 'numero',
                    label: 'Número',
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'almoxarifadoSaida.createdAt',
                    key: 'dataSaida',
                    label: 'Data da saída',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'finalizada',
                    label: 'Finalizada',
                    class: 'col-min',
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min',
                },
            ]
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleEdit(item) {

            const data = moment(item.dataSaida, 'DD/MM/YYYY').format('YYYY-MM-DD')

            this.setLoading()

            this.repositories.balancete.checkDate(data)
                .then(({ data }) => {

                    if (!data.mesFechado) {

                        this.$router.push({ name: 'almoxarifado-saida-edit', params: { id: item.id } })

                        return
                    }

                    this.showValidationNotification(
                        'A data da saída corresponde a um mês já finalizado. Alteração não permitida.'
                    )
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDestroy({ id }) {

            const destroy = () => this.repositories.saida.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a saída?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error, formats ],
}
</script>